import { type FC, useState } from 'react'
import { Link } from 'react-router-dom'

import type { TServicesCardProps } from './types'
import styles from './ServicesCard.module.scss'

const ServicesCard: FC<TServicesCardProps> = ({ title, to, Icon, HoverIcon }) => {
  const [isHover, setIsHover] = useState(false)

  return (
    <Link
      to={to}
      className={styles.card}
      onMouseOver={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <div className={styles.card__iconWrap}>
        {isHover ? <HoverIcon className={styles.card__icon} /> : <Icon className={styles.card__icon} />}
      </div>
      <span className={styles.card__name}>
        {title}
        <span className={styles.card__arrow} aria-hidden />
      </span>
    </Link>
  )
}

export default ServicesCard
